module.exports = __webpack_public_path__ + "static/media/male-scientist_1f468-200d-1f52c-2.3fab9775.png";